import React, { Fragment, useEffect, useState } from 'react';
import './SectionPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import {useParams} from "react-router-dom";

import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

import { Tab, Tabs } from "react-bootstrap";
import { getProviderAuthorisedSurveyList } from "root/DataFunctions/ProviderFns";
import SectionPageSurvey from "root/Questions/SectionPageSurvey";
import { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const SectionPageBody = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: []});

    let { provider_id, academic_year } = useParams();

    const { getCustomObject, isFeatureEnabled } = useGlobalContext() ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {

        const apiProviderId = provider_id === undefined ? 'current' : encodeURIComponent(provider_id) ;

        getProviderAuthorisedSurveyList(apiProviderId, null, (response) =>
        {
            const responseData = getDataFromResponse(response);

            setData({isLoading: false, data: responseData});
        });
    };

    const tabList = () =>
    {
        return ( data.data.map (( item ) =>
        {
            return <Tab key={item.survey_identifier} eventKey={item.survey_identifier} title={ item.survey_description} >
                <SectionPageSurvey survey_id={item.survey_id} academic_year={academic_year} provider_id={encodeURIComponent(provider_id)} />
            </Tab>

        })) ;
    }

    // const sectionsPage = sessionContext.getSectionsTitle() ;
    const sectionsPage = getCustomObject( ConfigOptions.SECTION_PAGE_TITLE ) ;

    return (
        <Fragment>
            <PageBodyWrapper title={ sectionsPage }>
                <div className='container-for-tabs'>
                    { data.isLoading === false &&
                        <Tabs defaultActiveKey={ data.data[ 0 ].survey_identifier } id="surveys-tab" className="mb-3"
                              mountOnEnter={ true }>
                            { tabList () }
                        </Tabs>
                    }
                </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default SectionPageBody;
